import { Sparkle } from "lucide-react";

const ITEMS = [
  "Taste the Tradition",
  "100% Pure Vegetarian",
  "Hand-Ground Podi",
  "Free Home Delivery Up to 3 KM",
  "Ghee-Roasted Dosas",
  "Authentic South Indian",
  "Sohna City, Gurgaon",
  "Degree Filter Coffee",
];

const Row = ({ ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {ITEMS.map((item) => (
      <span
        key={item}
        className="flex items-center gap-6 pr-6 font-mono-accent text-xs uppercase tracking-[0.35em] text-[#FFB74D]/90 sm:text-sm"
      >
        {item}
        <Sparkle size={13} className="text-[#388E3C]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    data-testid="marquee-strip"
    className="overflow-hidden border-y border-[#F57C00]/15 bg-gradient-to-r from-[#1a1206] via-[#120c05] to-[#1a1206] py-5"
  >
    <div className="marquee-track">
      <Row />
      <Row ariaHidden />
    </div>
  </section>
);

export default Marquee;
